// extracted by mini-css-extract-plugin
export default {"button":"button_button__allTB","disable_class":"button_disable_class__MNOGW","buttonCaption":"button_buttonCaption__UDQ7H","spinner":"button_spinner__iwX+w"};